import axios from "axios";
import { POWER_BI_API_URLS } from "./constants";
import { IRequestGetPowerBiReportInfo } from "./interfaces";

/** api call --> get report information */
export const getPowerBiReportInformation = async (
  request: IRequestGetPowerBiReportInfo,
) => {
  return await axios
    .get(`${POWER_BI_API_URLS.GET_POWER_BI_REPORT}?reportId=${request.id}`)
    .then(
      (resp: any) => {
        return resp.data;
      },
      (err: any) => {
        return err;
      },
    );
};
